import React from 'react';
import ProductSection from './ProductSection';
import { useCategories } from '../hooks/useCategories';

const DESCRIPTIONS = {
  'bow-ties': 'Handcrafted bow ties that combine tradition with contemporary style',
  'neckties': 'Premium neckties for the modern gentleman',
};

const CategorySections = () => {
  const categories = useCategories();
  return (
    <>
      {categories.map((c) => (
        <ProductSection
          key={c.slug}
          category={c.slug}
          title={`${c.name} Collection`}
          description={DESCRIPTIONS[c.slug] || `Explore our ${c.name.toLowerCase()} collection`}
        />
      ))}
    </>
  );
};

export default CategorySections;
